<div id="wrapper" #wrapper>
  <div>
    <div id="left-column">
      <div class="form-group">
        <label> Inspection Version: </label>
        <select
          class="form-control"
          style="display: inline-block; width: auto; margin-right: 15px"
          [(ngModel)]="versionName">
          <option *ngFor="let v of versions" [value]="v.name">
            {{ v.label }} {{ v.tags?.length ? '[' + v.tags + ']' : '' }}
          </option>
        </select>
        <label> Show questions: </label>
        <select class="form-control" style="display: inline-block; width: auto" [(ngModel)]="questionFilter">
          <option value="all">All questions</option>
          <option value="mandatory">Mandatory questions only</option>
          <option *ngIf="scoresEnabled" value="score">Scored questions only</option>
          <option *ngIf="scoresEnabled" value="mandatoryOrScored">Mandatory or Scored questions only</option>
          <option *ngIf="scoresEnabled" value="autoScored">Auto-scored</option>
        </select>
      </div>

      <div style="display: flex; height: 100%; margin-top: -100px; padding-top: 100px">
        <div class="section-column">
          <div class="column-header">
            <h4>
              <span style="float: left">Section</span>
              <button style="float: right" class="btn btn-link btn-sm" (click)="openSelectedItem()">
                Change order
              </button>
            </h4>
          </div>
          <div class="scrollable" forScroll>
            <ng-container *ngFor="let currentSections of allSectionsByItem | keyvalue; index as i">
              <div
                class="item-level"
                [ngClass]="{ last: i === allSectionsByItem.length - 1 }"
                cdkDropList
                (cdkDropListDropped)="dropSection($event)">
                <div
                  *ngFor="let item of currentSections.value"
                  cdkDrag
                  [cdkDragData]="{ sections: currentSections.value, section: item }"
                  [ngClass]="{ 'card-active': selectedSection?.id == item.id }"
                  (click)="selectSetion(item)"
                  class="card-section">
                  <div>
                    <span class="card-name">{{ item.item?.name }}</span
                    ><br />
                    <span class="card-item">{{ item.name }}</span>
                  </div>
                  <span cdkDragHandle class="grip"></span>
                  <div class="score-badge-tree" *ngIf="isInvalidSection(item.id)">
                    <span class="fa fa-warning"></span>
                  </div>
                </div>
              </div>
            </ng-container>
          </div>
        </div>

        <div class="question-column">
          <div class="column-header">
            <h4>
              <span style="float: left">Question</span>
              <button style="float: left" class="btn btn-link btn-sm" (click)="addQuestion()">Add new</button>
              <button style="float: right" class="btn btn-link btn-sm" (click)="openSelectedSection()">
                Change order
              </button>
            </h4>
          </div>
          <div *ngIf="Qloading" class="d-flex flex justify-content-center spinner-wrapper">
            <span class="spinner-tree"></span>
          </div>
          <div class="scrollable" forScroll *ngIf="!Qloading">
            <div cdkDropList (cdkDropListDropped)="dropQuestion($event)">
              <ng-container *ngFor="let item of questions; index as i">
                <div
                  *ngIf="showQuestion(item)"
                  [ngClass]="{ 'card-active': selectedQuestion?.id == item.id, flex: true }"
                  cdkDrag
                  [cdkDragData]="{ questions: questions, question: item }"
                  class="card-section"
                  [routerLink]="'/question/tree/' + item.id"
                  [queryParams]="{ versionName: versionName }"
                  tabindex="-1">
                  <div>
                    <span class="question-order">
                      {{ i + 1 }}
                    </span>
                  </div>
                  <div class="card-question-text" style="flex: 1">
                    {{ item.text }}
                    <span *ngIf="item.mandatoryReview" style="color: #dc3e3e; font-weight: bold">*</span>
                  </div>
                  <span cdkDragHandle class="grip"></span>
                  <div class="score-badge-tree" *ngIf="isInvalidQuestion(item.id)">
                    <span class="fa fa-warning"></span>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div id="right-column">
      <div *ngIf="!selectedQuestion">
        <h2>Select a question</h2>
      </div>

      <div id="question" *ngIf="selectedQuestion">
        <div>
          <h2>{{ selectedQuestion.text }}</h2>
          <span style="color: #dc3e3e" *ngIf="!hasAllHelp()"
            >* Please don’t forget to fill in Help fields (inc. each of the options for picklist questions)</span
          >
          <hr />
        </div>

        <div class="scrollable" style="padding-left: 5px" forScroll>
          <form [formGroup]="form" (submit)="submit()">
            <h5>Basic info</h5>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Text</label>
                  <textarea
                    class="form-control"
                    formControlName="text"
                    [ngClass]="getValidationClass('text')"></textarea>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Legacy ID</label>
                  <input class="form-control" formControlName="legacyId" [ngClass]="getValidationClass('legacyId')" />
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Section</label>
                  <select class="form-control" formControlName="section" [ngClass]="getValidationClass('section')">
                    <option *ngFor="let t of allSections" [ngValue]="t.id">{{ t.name }}</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row" *ngIf="selectedSection?.item?.allowRepeat">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name"
                    >Repeat
                    <small style="cursor: pointer" (click)="form.get('repeat').setValue(null)">(clear)</small>
                  </label>
                  <div>
                    <ng-container *ngFor="let item of repeatOptions">
                      <input type="radio" [value]="item.id" formControlName="repeat" /> {{ item.name }} <br />
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <h5>Answer</h5>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Type</label>
                  <select class="form-control" formControlName="type">
                    <option value="free-text">Free Text</option>
                    <option value="pick-list">Pick List</option>
                    <option value="picture-only">Picture Only</option>
                    <option value="location-only">Location Only</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row" *ngIf="form.get('type').value == 'pick-list'">
              <div class="col-md-12">
                <div class="form-group">
                  <label>Options</label>
                  <div *ngIf="form.get('options').hasError('required')">
                    <span style="color: #dc3e3e">* Options are required for the pick list type.</span>
                  </div>
                  <div formArrayName="options">
                    <div class="question-option" *ngFor="let item of getOptions(); let i = index">
                      <div [formGroupName]="i" style="display: flex">
                        <div style="flex: 1">
                          <div>
                            {{ item?.getRawValue()?.text }}
                            <span
                              *ngIf="scoresEnabled && item?.getRawValue()?.flaggingScore"
                              style="color: #dc3e3e; font-size: 12px">
                              ({{ item?.getRawValue()?.flaggingScore }})
                            </span>
                          </div>
                        </div>
                        <div>
                          <button type="button" title="Edit Option" class="btn" (click)="openOption(item)">
                            <i class="fa fa-pencil fa-lg"></i></button
                          ><button type="button" title="Remove Option" class="btn" (click)="removeOption(i)">
                            <i class="fa fa-trash-o fa-lg"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <button
                    class="btn btn-outline-primary aru"
                    style="margin-top: 10px"
                    type="button"
                    (click)="addOption()">
                    Add
                  </button>
                </div>
              </div>
            </div>

            <h5>Review</h5>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <p *ngIf="form.get('inspectorVisibility').value === 'conditional'">
                    The review requirement for this question is set by the "Inspector Visibility" conditional question.
                  </p>
                  <p *ngIf="form.get('inspectorVisibility').value === 'never'">Admin-only questions must be reviewed</p>
                  <input
                    type="radio"
                    [value]="true"
                    formControlName="mandatoryReview"
                    id="mandatoryReviewTrue"
                    [attr.disabled]="form.get('inspectorVisibility').value !== 'always' ? 1 : null" />
                  <label style="margin-left: 10px; cursor: pointer" for="mandatoryReviewTrue"
                    >This question is mandatory for review</label
                  >
                  <br />
                  <input
                    type="radio"
                    [value]="false"
                    formControlName="mandatoryReview"
                    id="mandatoryReviewFalse"
                    [attr.disabled]="form.get('inspectorVisibility').value !== 'always' ? 1 : null" />
                  <label style="margin-left: 10px; cursor: pointer" for="mandatoryReviewFalse"
                    >This question is NOT mandatory for review</label
                  >
                </div>
              </div>
            </div>

            <h5>Tags</h5>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <type-ahead
                    formControlName="questionTags"
                    [suggestions]="questionTags"
                    placeholder="Add question tags..."
                    class="form-control"
                    [custom]="true"
                    [multi]="true"
                    [itemTemplate]="tagsTemplate">
                  </type-ahead>
                  <ng-template #tagsTemplate let-item="item">
                    {{ item.name }}
                  </ng-template>
                </div>
              </div>
            </div>

            <h5>Auto-flag groups</h5>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <type-ahead
                    formControlName="flagGroupTags"
                    [suggestions]="flagGroupTags"
                    placeholder="Add question auto-flag groups..."
                    class="form-control"
                    [custom]="false"
                    [multi]="true"
                    [itemTemplate]="tagsTemplate">
                  </type-ahead>
                  <ng-template #tagsTemplate let-item="item">
                    {{ item.name }}
                  </ng-template>
                </div>
              </div>
            </div>

            <h5>Help</h5>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Description</label>
                  <app-markdown id="helpEditor" formControlName="helpText"></app-markdown>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Pictures</label>

                  <div *ngIf="!form.get('helpPictures').controls?.length" style="margin-bottom: 20px">
                    No images attached
                  </div>

                  <div *ngIf="selectedQuestion">
                    <div *ngIf="form.get('helpPictures').controls?.length" style="margin-bottom: 20px">
                      <div
                        *ngFor="let p of form.get('helpPictures').controls; let i = index"
                        style="display: inline-block; max-width: 250px; margin: 10px">
                        <div [formGroup]="p">
                          <span
                            style="
                              display: inline-block;
                              width: 240px;
                              min-height: 75px;
                              box-shadow: 0px 0px 7px #000;
                              margin: 5px;
                              position: relative;
                            ">
                            <img-ajax [src]="getSrc(p.value)"></img-ajax>
                            <span style="position: absolute; left: 5px; top: 5px"
                              ><button type="button" class="btn btn-danger btn-sm" (click)="removeImage(i)">
                                X
                              </button></span
                            >
                          </span>
                          <br />
                          <app-markdown id="optionEditor" formControlName="caption" [options]="{ height: 150 }">
                          </app-markdown>
                        </div>
                      </div>
                    </div>
                    <ng-container *ngIf="canEditHelp">
                      <div class="d-flex flex justify-content-between">
                        <input type="file" (change)="setUploadFile($event.target.files)" #helpFilePic />
                        <button
                          type="button"
                          class="btn btn-primary aru flex"
                          (click)="uploadFile(helpFilePic)"
                          [disabled]="!helpFilePic.value || helpPicturesloading">
                          <span> {{ helpPicturesloading ? 'Uploading' : 'Upload' }} </span>
                          <span *ngIf="helpPicturesloading" class="ml-2 spinner-tree"></span>
                        </button>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </div>
            </div>

            <h5>
              Admin Visibility
              <span *ngIf="isInvalidQuestionType('Admin Visibility')" class="fa fa-warning red-warning"></span>
            </h5>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Show</label>
                  <select
                    class="form-control"
                    formControlName="adminVisibility"
                    [ngClass]="getValidationClass('adminVisibility')">
                    <option value="always">Always</option>
                    <option value="conditional">Conditional</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row" *ngIf="form.get('adminVisibility').value == 'conditional'">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Section</label>
                  <select
                    class="form-control"
                    formControlName="adminVisibilitySection"
                    [ngClass]="getValidationClass('adminVisibilitySection')">
                    <option *ngFor="let s of pickSections" [ngValue]="s">{{ s?.name }} ({{ getItemName(s) }})</option>
                  </select>
                  <span class="text-danger" *ngIf="form.get('adminVisibilitySection').errors?.minInstances"
                    >The selected Item has a "Minimum Quantity" set to zero, so it cannot be used in conditional
                    logic.</span
                  >
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Question</label>
                  <select
                    class="form-control"
                    formControlName="adminVisibilityQuestion"
                    [ngClass]="getValidationClass('adminVisibilityQuestion')">
                    <option *ngFor="let q of pickQuestionsAdmin" [ngValue]="q">{{ q.text }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Answer</label>
                  <select
                    class="form-control"
                    formControlName="adminVisibilityAnswer"
                    [ngClass]="getValidationClass('adminVisibilityAnswer')">
                    <option *ngFor="let a of form.get('adminVisibilityQuestion')?.value?.options" [value]="a?.text">
                      {{ a?.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <h5>Admin picture Visibility</h5>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Show</label>
                  <select class="form-control" formControlName="showRelated">
                    <option [ngValue]="false">Only original pictures</option>
                    <option [ngValue]="true">Original and additional pictures</option>
                  </select>
                </div>
              </div>
            </div>

            <div *ngIf="form.get('showRelated').value">
              <label for="name">Related questions</label>

              <div class="related-question" *ngFor="let q of selectedQuestion?.related">
                <div style="display: flex">
                  <div style="flex: 1">
                    <div tabindex="-1" [routerLink]="'/question/tree/' + q.id">
                      {{ q.section?.name }} / {{ q.text }}
                    </div>
                  </div>
                  <div>
                    <button type="button" title="Remove" class="btn" (click)="removeRelated(q)">
                      <i class="fa fa-trash-o fa-lg"></i>
                    </button>
                  </div>
                </div>
              </div>

              <label for="name">New Related Question</label>
              <div class="form-group">
                <select class="form-control" formControlName="newRelatedSection">
                  <option *ngFor="let s of pickSectionsRelated" [ngValue]="s">
                    {{ s?.name }} ({{ getItemName(s) }})
                  </option>
                </select>
              </div>
              <div class="form-group">
                <select class="form-control" [(ngModel)]="newRelatedQuestion" [ngModelOptions]="{ standalone: true }">
                  <option *ngFor="let q of pickQuestionsRelated" [ngValue]="q">{{ q.text }}</option>
                </select>
              </div>
              <button
                class="btn btn-outline-primary aru"
                type="button"
                [disabled]="!newRelatedQuestion"
                (click)="addRelated()">
                Add
              </button>
            </div>

            <h5>
              Inspector Visibility
              <span *ngIf="isInvalidQuestionType('Inspector Visibility')" class="fa fa-warning red-warning"></span>
            </h5>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Show</label>
                  <select
                    class="form-control"
                    formControlName="inspectorVisibility"
                    [ngClass]="getValidationClass('inspectorVisibility')">
                    <option value="always">Always</option>
                    <option value="never">Never</option>
                    <option value="conditional">Conditional</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row" *ngIf="form.get('inspectorVisibility').value == 'conditional'">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Section</label>
                  <select
                    class="form-control"
                    formControlName="inspectorVisibilitySection"
                    [ngClass]="getValidationClass('inspectorVisibilitySection')">
                    <option *ngFor="let s of pickSections" [ngValue]="s">{{ s?.name }} ({{ getItemName(s) }})</option>
                  </select>
                  <span class="text-danger" *ngIf="form.get('inspectorVisibilitySection').errors?.minInstances"
                    >The selected Item has a "Minimum Quantity" set to zero, so it cannot be used in conditional
                    logic.</span
                  >
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Question</label>
                  <select
                    class="form-control"
                    formControlName="inspectorVisibilityQuestion"
                    [ngClass]="getValidationClass('inspectorVisibilityQuestion')">
                    <option *ngFor="let q of pickQuestionsInspector" [ngValue]="q">{{ q.text }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Answer</label>
                  <select
                    class="form-control"
                    formControlName="inspectorVisibilityAnswer"
                    [ngClass]="getValidationClass('inspectorVisibilityAnswer')">
                    <option *ngFor="let a of form.get('inspectorVisibilityQuestion')?.value?.options" [value]="a?.text">
                      {{ a?.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>

            <h5>
              Picture Required
              <span *ngIf="isInvalidQuestionType('Picture Required')" class="fa fa-warning red-warning"></span>
            </h5>

            <div *ngIf="form.get('type').value !== 'picture-only'">
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="name">When</label>
                    <select
                      class="form-control"
                      formControlName="pictureRequired"
                      [ngClass]="getValidationClass('pictureRequired')">
                      <option value="optional">Optional</option>
                      <option value="always">Always</option>
                      <option value="conditional">Conditional</option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="row" *ngIf="form.get('pictureRequired').value == 'conditional'">
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="name">Section</label>
                    <select
                      class="form-control"
                      formControlName="pictureRequiredSection"
                      [ngClass]="getValidationClass('pictureRequiredSection')">
                      <option *ngFor="let s of pickSections" [ngValue]="s">{{ s?.name }} ({{ getItemName(s) }})</option>
                    </select>
                    <span class="text-danger" *ngIf="form.get('pictureRequiredSection').errors?.minInstances"
                      >The selected Item has a "Minimum Quantity" set to zero, so it cannot be used in conditional
                      logic.</span
                    >
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="name">Question</label>
                    <select
                      class="form-control"
                      formControlName="pictureRequiredQuestion"
                      [ngClass]="getValidationClass('pictureRequiredQuestion')">
                      <option *ngFor="let q of pickQuestionsPicture" [ngValue]="q">{{ q.text }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="form-group">
                    <label for="name">Answer</label>
                    <select
                      class="form-control"
                      formControlName="pictureRequiredAnswer"
                      [ngClass]="getValidationClass('pictureRequiredAnswer')">
                      <option *ngFor="let a of form.get('pictureRequiredQuestion')?.value?.options" [value]="a?.text">
                        {{ a?.text }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div
              class="row"
              *ngIf="form.get('pictureRequired').value != 'optional' || form.get('type').value == 'picture-only'">
              <div class="col-md-6">
                <div class="form-group">
                  <label for="name">Orientation</label>
                  <select class="form-control" formControlName="pictureOrientation">
                    <option value="landscape">Landscape</option>
                    <option value="portrait">Portrait</option>
                    <option value="any">Any</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-group">
                  <label for="name">Guidance Text</label>
                  <input class="form-control" formControlName="pictureGuidanceText" />
                </div>
              </div>
            </div>

            <ng-container *ngIf="form.get('type').value !== 'location-only'">
              <h5>
                Location Required
                <span *ngIf="isInvalidQuestionType('Location Required')" class="fa fa-warning red-warning"></span>
              </h5>

              <div>
                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="name">When</label>
                      <select
                        class="form-control"
                        formControlName="locationRequired"
                        [ngClass]="getValidationClass('locationRequired')">
                        <option value="optional">Optional</option>
                        <option value="always">Always</option>
                        <option value="conditional">Conditional</option>
                      </select>
                    </div>
                  </div>
                </div>

                <div class="row" *ngIf="form.get('locationRequired').value == 'conditional'">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="name">Section</label>
                      <select
                        class="form-control"
                        formControlName="locationRequiredSection"
                        [ngClass]="getValidationClass('locationRequiredSection')">
                        <option *ngFor="let s of pickSections" [ngValue]="s">
                          {{ s?.name }} ({{ getItemName(s) }})
                        </option>
                      </select>
                      <span class="text-danger" *ngIf="form.get('locationRequiredSection').errors?.minInstances"
                        >The selected Item has a "Minimum Quantity" set to zero, so it cannot be used in conditional
                        logic.</span
                      >
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="name">Question</label>
                      <select
                        class="form-control"
                        formControlName="locationRequiredQuestion"
                        [ngClass]="getValidationClass('locationRequiredQuestion')">
                        <option *ngFor="let q of pickQuestionsPosition" [ngValue]="q">{{ q.text }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="col-md-12">
                    <div class="form-group">
                      <label for="name">Answer</label>
                      <select
                        class="form-control"
                        formControlName="locationRequiredAnswer"
                        [ngClass]="getValidationClass('locationRequiredAnswer')">
                        <option
                          *ngFor="let a of form.get('locationRequiredQuestion')?.value?.options"
                          [value]="a?.text">
                          {{ a?.text }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </ng-container>

            <h5>
              Notes Required
              <span *ngIf="isInvalidQuestionType('Notes Required')" class="fa fa-warning red-warning"></span>
            </h5>

            <div class="row">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">When</label>
                  <select
                    class="form-control"
                    formControlName="notesRequired"
                    [ngClass]="getValidationClass('notesRequired')">
                    <option value="optional">Optional</option>
                    <option value="always">Always</option>
                    <option value="conditional">Conditional</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="row" *ngIf="form.get('notesRequired').value == 'conditional'">
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Section</label>
                  <select
                    class="form-control"
                    formControlName="notesRequiredSection"
                    [ngClass]="getValidationClass('notesRequiredSection')">
                    <option *ngFor="let s of pickSections" [ngValue]="s">{{ s?.name }} ({{ getItemName(s) }})</option>
                  </select>
                  <span class="text-danger" *ngIf="form.get('notesRequiredSection').errors?.minInstances"
                    >The selected Item has a "Minimum Quantity" set to zero, so it cannot be used in conditional
                    logic.</span
                  >
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Question</label>
                  <select
                    class="form-control"
                    formControlName="notesRequiredQuestion"
                    [ngClass]="getValidationClass('notesRequiredQuestion')">
                    <option *ngFor="let q of pickQuestionsNotes" [ngValue]="q">{{ q.text }}</option>
                  </select>
                </div>
              </div>
              <div class="col-md-12">
                <div class="form-group">
                  <label for="name">Answer</label>
                  <select
                    class="form-control"
                    formControlName="notesRequiredAnswer"
                    [ngClass]="getValidationClass('notesRequiredAnswer')">
                    <option *ngFor="let a of form.get('notesRequiredQuestion')?.value?.options" [value]="a?.text">
                      {{ a?.text }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
          </form>
        </div>

        <div>
          <hr />
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <button *ngIf="canEdit || canEditHelp" type="button" class="btn btn-primary aru" (click)="submit()">
                  Save
                </button>
                <button *ngIf="canEdit" type="button" class="btn btn-ghost-danger aru" (click)="archive()">
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<app-confirm #confirm></app-confirm>

<div bsModal #optionModal="bs-modal" class="modal" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name">
  <div class="modal-dialog modal-lg" *ngIf="editingOption">
    <div class="modal-content">
      <div class="modal-header" *ngIf="header">
        <h4 id="dialog-child-name" class="modal-title pull-left">{{ header }}</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="cancelOption()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding: 25px">
        <form [formGroup]="editingOption" style="padding: 10px">
          <div class="form-group">
            <label for="text">Text</label>
            <input class="form-control" formControlName="text" />
          </div>
          <div *ngIf="scoresEnabled" class="form-group">
            <label for="text">Auto-flag Score</label>
            <select class="form-control" formControlName="flaggingScore">
              <option [ngValue]="0">0</option>
              <option [ngValue]="1">1</option>
              <option [ngValue]="3">3</option>
              <option [ngValue]="5">5</option>
              <option [ngValue]="10">10</option>
              <option [ngValue]="100">100</option>
            </select>
          </div>
          <div class="form-group" *ngIf="scoresEnabled && editingOption.get('flaggingScore').value">
            <label for="text">Auto-flag Comment</label>
            <input class="form-control" formControlName="flaggingComment" />
          </div>
          <div class="form-group">
            <label for="helpText">Help</label>
            <app-markdown id="optionEditor" formControlName="helpText"></app-markdown>
          </div>
          <div class="row">
            <div class="col-md-12">
              <div class="form-group">
                <label for="name">Pictures</label>

                <div *ngIf="!editingOption?.value.helpPictures?.length" style="margin-bottom: 20px">
                  No images attached
                </div>
                <div *ngIf="editingOption?.value.helpPictures?.length" style="margin-bottom: 20px">
                  <div
                    *ngFor="let p of editingOption.get('helpPictures').controls; let i = index"
                    style="display: inline-block; max-width: 250px; margin: 10px">
                    <div [formGroup]="p">
                      <span
                        style="
                          display: inline-block;
                          width: 240px;
                          box-shadow: 0px 0px 7px #000;
                          margin: 5px;
                          position: relative;
                        ">
                        <img-ajax [src]="getSrc(p.value)"></img-ajax>
                        <span style="position: absolute; left: 5px; top: 5px"
                          ><button type="button" class="btn btn-danger btn-sm" (click)="removeOptionImage(i)">
                            X
                          </button></span
                        >
                      </span>
                      <br />
                      <app-markdown id="optionEditor" formControlName="caption" [options]="{ height: 150 }">
                      </app-markdown>
                    </div>
                  </div>
                </div>
                <input type="file" (change)="setUploadFile($event.target.files)" #optionFilePic />
                <button
                  type="button"
                  class="btn btn-primary aru"
                  (click)="uploadOptionFile(optionFilePic)"
                  [disabled]="!optionFilePic.value">
                  Upload
                </button>
              </div>
            </div>
          </div>
        </form>
        <button type="button" class="btn btn-primary aru" (click)="closeOption()">Confirm</button>
        <button type="button" class="btn btn-default aru" (click)="cancelOption()">Cancel</button>
      </div>
    </div>
  </div>
</div>

<div bsModal #validationModal="bs-modal" class="modal" tabindex="-1" role="dialog" aria-labelledby="dialog-child-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-child-name" class="modal-title pull-left">Validation Problem</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="validationModal.hide()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="padding: 25px">
        {{ validationQuestions.length > 1 ? 'These questions' : 'This question' }}
        can't be deleted because
        {{ validationQuestions.length > 1 ? 'they are' : 'it is' }}
        used as a condition in other question(s):

        <ul>
          <li *ngFor="let q of validationQuestions">
            <a
              [routerLink]="'/question/tree/' + q.originalId"
              [queryParams]="{ versionName: versionName }"
              (click)="validationModal.hide()"
              >{{ q.questionText }} ({{ q.type }})</a
            >
          </li>
        </ul>

        <hr />
        <button type="button" class="btn btn-primary aru" (click)="validationModal.hide()">OK</button>
      </div>
    </div>
  </div>
</div>

<app-validation-guide
  *ngIf="invalidQuestions?.length"
  [invalidQuestions]="invalidQuestions"
  (questionClick)="goToQuestion($event)"></app-validation-guide>
